import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { GetAvatar } from 'Utils/generateThumbnail';
import { Icon } from 'Components/UI';
import { ColumnProps } from 'antd/lib/table';
import { MinhaContaActions } from 'Store/MinhaConta/MinhaConta.actions'
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import Ellipsis from 'Components/UI/Ellipsis';
import BoxContainer from 'Components/UI/Containers/BoxContainer/BoxContainer';
import Table from 'Components/UI/Table';
import { dateToLocaleString } from 'Utils/DateUtils';
import { stringToPhone } from 'Utils/MaskUtils';
import styles from './DetalhesConta.module.scss';

export interface IDados {
  title: string;
  value: string
}
const DetalhesConta: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('minhaConta');

  const requiredLabel = t('common:required', { ns: 'common' });

  const newDadosSeguranca = () => {
    return [{ title: t('detalhesConta.fieldPassword'), value: '********' }];
  };

  const newDadosAcesso = () => {
    const dadosAcesso = [];
    const positionsStudent = ['Estudante de Engenharia', 'Estudante de Arquitetura', 'Estagiário'];
    const hasPhone = props.userInfo.Telefone && props.userInfo.Telefone !== '';

    dadosAcesso.push(
      { title: t('detalhesConta.fieldEmail'), value: props.userInfo.Email },
      { title: t('detalhesConta.fieldAlternativeEmail'), value: props.userInfo.EmailAlternativo },
      {
        title: hasPhone ? t('detalhesConta.fieldPhone') : t('detalhesConta.fieldPhoneRequired'),
        value: hasPhone ? stringToPhone(props.userInfo.Telefone) : '*'
      }
    );

    if (positionsStudent.indexOf(props.userInfo.CompanyPosition?.Name, 0) !== -1) {
      dadosAcesso.push({ title: t('detalhesConta.fieldCollege'), value: props.userInfo.Faculdade });
    }

    return dadosAcesso;
  };

  const newDadosBasicos = () => [
    { title: t('detalhesConta.fieldName'), value: props.userInfo.Nome },
    { title: t('detalhesConta.fieldRole'), value: props.userInfo.CompanyPosition?.Name }
  ];

  const collumnsTable = (title: string, isSecurity: boolean): Array<ColumnProps<any>> => {
    return [
      {
        title,
        dataIndex: 'title',
        className: styles['dadoObrigatorio'],
        render: (text) => (
          <div className={styles['titleItem']}>
            <span className={styles[text.substr(-1, 1) === '*' ? 'titleObrigatorio' : 'title']}>{text}</span>
          </div>
        )
      },
      {
        title: (
          <div className={styles['icon']}>
            <Icon
              color='cinzaIcone'
              icon='editar'
              onClick={isSecurity
                ? () => dispatch(MinhaContaActions.setShowModalUpdatePassword(true))
                : () => dispatch(MinhaContaActions.setShowModalUpdateConta(true))
              }
            />
          </div>
        ),
        dataIndex: 'value',
        className: styles['dadoObrigatorio'],
        render: (text) => (
          <div className={styles['valueItem']}>
            <span
              title={text === '*' ? requiredLabel : text}
              className={styles[text === '*' ? 'valueObrigatorio' : 'value']}
            >
              {text === '*' ? requiredLabel : text}
            </span>
          </div>
        )
      }
    ];
  };

  return (
    <>
      <BoxContainer height={228}>
        <div className={styles['minhaContaImg']}>
          <GetAvatar
            name={props.userInfo.Nome || ''}
            shape='square'
            fontSize={50}
            src={props?.userInfo?.OriginalImageUrl}
            thumbSrc={props.userInfo?.ThumbnailImageUrl}
            thumbType="big"
          />
        </div>

        <div className={styles['minhaContaName']}>
          <strong>
            <Ellipsis phrase={props.userInfo.Nome || ''} maxLength={13} />
          </strong>
        </div>
        <div className={styles['minhaContaDataCadastro']} style={{ visibility: props.userInfo.DateCreate ? 'visible' : 'hidden' }}>
          <span className={styles['dataCadastro']}>
            {t('detalhesConta.memberSince', {
              date: props.userInfo.DateCreate ? dateToLocaleString(new Date(props.userInfo.DateCreate)) : ''
            })}
          </span>
        </div>
      </BoxContainer>

      <div className={styles['dadosContaLeft']}>
        <Table
          dataSource={newDadosBasicos().map((dado, index) => ({ ...dado, key: index }))}
          columns={collumnsTable(t('detalhesConta.tableSectionBasic'), false)}
        />
        <Table
          className={styles['dadosSeguranca']}
          dataSource={newDadosSeguranca().map((dado, index) => ({ ...dado, key: index }))}
          columns={collumnsTable(t('detalhesConta.tableSectionSecurity'), true)}
        />
      </div>

      <div className={styles['dadosContaRight']}>
        <Table
          dataSource={newDadosAcesso().map((dado, index) => ({ ...dado, key: index }))}
          columns={collumnsTable(t('detalhesConta.tableSectionAccess'), false)}
        />
      </div>
    </>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.minhaConta,
});

const connector = connect(
  mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(DetalhesConta);
